import cx from 'classnames';
import { photoUrl } from 'mk/photo/photoUrl';
import { Img } from 'mk2/components/Img';
import { PhotoEntity } from 'mk2/schemas';
import React from 'react';
import styles from './ImgVarHeight.mscss';

interface OwnPropsShared {
    className?: string;

    // width the image, should be scaled to.
    width: number;

    // if true, image can be upscaled
    // when props.photo.with is smaller than props.width
    upscale?: boolean;

    alt?: string;
}

type OwnPropsWithPhoto = OwnPropsShared & {
    photo: PhotoEntity;
    photoVersion: string;

    src?: never;
    imgWidth?: never;
    imgHeight?: never;
};

type OwnPropsWithSrc = OwnPropsShared & {
    src: string;

    // dimension of the image (jpg) passed as src
    imgWidth: number;
    imgHeight: number;

    photo?: never;
    photoVersion?: never;
};

/**
 * Scales images into the box of size width x height. Width is given as parameter. Keeping aspect ratio, height
 * is computed from image dimensions.
 */
export class ImgVarHeight extends React.Component<OwnPropsWithPhoto | OwnPropsWithSrc> {

    public render() {
        const { className, upscale, alt } = this.props;

        let src: string;
        let height: number;
        let width: number;

        if ((this.props as any).photo) {
            const pprops = this.props as OwnPropsWithPhoto;
            src = photoUrl(pprops.photo, pprops.photoVersion);
            width = upscale ? pprops.width : Math.min(pprops.width, pprops.photo.width);
            height = (pprops.photo.height * width) / pprops.photo.width;
        } else {
            const sprops = this.props as OwnPropsWithSrc;
            src = sprops.src;
            width = upscale ? sprops.width : Math.min(sprops.width, sprops.imgWidth);
            height = Math.round(sprops.imgHeight / sprops.imgWidth * width);
        }

        return (
            <Img
                src={src}
                height={height}
                width={width}
                alt={alt}
                className={cx(styles.ImgVarHeight, className)}
            />
        );
    }
}
